import { MENU_POST_ITEM } from '../../../constants/menu'
import { WEBAPP_ROUTE_PREFIX } from '../../../constants/route'

export function getRedirectUrlAfterLogin({ host, isNewsboardAvailable }) {
  return `https://${host}${isNewsboardAvailable ? MENU_POST_ITEM.to : '/' + WEBAPP_ROUTE_PREFIX}`
}
